import type { I18nTranslation } from '@crehana/i18n';

import { en } from './en';
import { es } from './es';
import { pt } from './pt';
import type { TKeys } from './types';

export const locales: I18nTranslation = { en, pt, es };

export { WHATSAPP_TEMPLATES_PAGE_KEY } from './constants';
export type { TKeys };
